import {z} from 'zod';

import {CheckoutProfileRuleConditionsSchema, CheckoutProfileRuleWriteSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

const selectedIds = z
  .array(z.string().uuid())
  .min(1, i18n.t('general.validations.fieldIsRequired'))
  .nullish();

export const CheckoutRuleFormSchema = CheckoutProfileRuleWriteSchema.innerType()
  .extend({
    sourceType: CheckoutProfileRuleWriteSchema.innerType()
      .shape.sourceType.nullable()
      .transform((value, context) => {
        if (value === null) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
          });

          return z.NEVER;
        }

        return value;
      }),
    conditions: CheckoutProfileRuleConditionsSchema.extend({
      serviceCaseTypeIds: selectedIds,
      serviceOrderTypeIds: selectedIds,
      serviceOrderVariantIds: selectedIds,
      authorizationProfileIds: selectedIds,
      directSaleTypeIds: selectedIds,
      directSaleVariantIds: selectedIds,
    }),
  })
  .pipe(CheckoutProfileRuleWriteSchema);
